import { ChangeDetectorRef, Component } from '@angular/core';
import { HelperService } from "./service/helper.service";
import { timer } from "rxjs";
import { NotifyManagementService } from "../../../fe-common-v2/src/lib/services/notify-management.service";
import { SwUpdate } from "@angular/service-worker";
import { Router } from "@angular/router";
import Swal from "sweetalert2";
import { SessionManagementService } from 'projects/fe-common-v2/src/lib/services/session-management.service';
import { TranslateService } from '@ngx-translate/core';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
    title = 'fe-customer';
    loaderVisible: boolean;

    constructor(private sessionManagementService: SessionManagementService,
        private helper: HelperService, private translate: TranslateService,
        private cdRef: ChangeDetectorRef,
        private notifyManagementService: NotifyManagementService,
        private swUpdate: SwUpdate,
        private router: Router,
    ) {
        this.helper.loaderVisibilityChange.subscribe((value) => {
            this.loaderVisible = value;
            this.cdRef.detectChanges();
        });

        sessionManagementService.onSessionExpired.subscribe(async () => {
            this.helper.toggleLoaderVisibility(false);
            //await this.notifyManagementService.openMessageDialog(this.translate.instant('GENERAL.PAY ATTENTION'), this.translate.instant('LOGIN PAGE.USER SESSION EXPIRED'));
            Swal.fire(
                this.translate.instant('GENERAL.PAY ATTENTION'),
                this.translate.instant('GENERAL.YOUR SESSION EXPIRED'),
                'info'
            ).then((res) => {
                this.router.navigate(['']);
            });
        });


    }

    ngOnInit(): void {
        let showing = false;
        if (this.swUpdate.isEnabled) {
            this.swUpdate.available.subscribe(async () => {
                if (!showing) {
                    showing = false;
                    await this.notifyManagementService.openMessageDialogNew('IRINA', 'E\' disponibile una nuova versione della App. Ti verrà chiesto di rifare il login per aggiornare. Grazie.');
                    HelperService.onLogOut();
                    this.router.navigate(['/']);
                    window.location.reload();
                }
            });
        }
        timer(3000, 3000).subscribe(() => this.swUpdate.checkForUpdate());
    }
}
